export default __webpack_public_path__ + "static/banner_back-f3daf289328ad8eb8f021f7f9289ba26.webp";